import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  patientId: yup.number(),
  templateId: yup.number(),
  clinicId: yup.number().required(),
  senderId: yup.number(),
  faxNumber: yup.string(),
  text: yup.string(),
});

export const useEfaxPatientMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) =>
      http.post(
        HTTP_ENDPOINTS.efax.createFaxes(),
        requestSchema.validateSync(dto, {
          strict: true,
        }),
      ),
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.efax.faxes],
        });

        options?.onSuccess?.(...args);
      },
    },
  );
};
